import React, { useState } from 'react';
import Ratio from 'react-bootstrap/Ratio';
import Modal from 'react-bootstrap/Modal';
import './video.scss';
import { RiLoader5Fill } from "react-icons/ri";



function VideoPopup(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className={`mx-2 video-popup ${props.theme || ''}`}>
        <button
          className="tw-size-20 tw-bg-black/75 tw-text-white tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-z-1 tw-rounded-full tw-p-5 tw-flex tw-items-center tw-justify-center"

          onClick={() => {setShow(true); 
          }}
        >
          {String(props.videoId) === String(props.activeId) ? props.videoLoading ?
            <RiLoader5Fill color='#000' className='' size={24} /> : <i className="fas fa-play fa-2x"/> : <i className="fas fa-play fa-2x"/>}
        </button>
        {!(props?.theme === 'video-style-2' || props.imageHide) && (
          <div className="tw-shadow tw-w-full tw-aspect-video">
            <img
              alt="videoImage"
              className="tw-w-full tw-aspect-video tw-object-contain"
              src={props.videoImage}
            />
          </div>
        )}

      </div>

      {!props.videoLoading && <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setShow(false)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter modal-content"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <p>{props.videoTitle}</p>
          <Ratio aspectRatio="16x9">
            <video width="320" height="240" controls autoPlay>
              <source src={props.videoURL} type="video/mp4" />
            </video>
          </Ratio>
        </Modal.Body>
      </Modal>}
    </>
  );
}

export default VideoPopup;
